var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","position":"relative"}},[_c('img',{staticClass:"development-img",attrs:{"src":"/img/development.jpg"}})])
}]

export { render, staticRenderFns }